import { LOB_MODULE, DB_MODULE } from '../constants';

export const LEGACY_LOB_MODULE = 'standard';
export const LEGACY_DB_MODULE = 'state';

export function normalizeModule(value, fallback = LOB_MODULE) {
  const normalizedFallback = fallback === null
    ? null
    : typeof fallback === 'string' && fallback !== value
      ? normalizeModule(fallback, LOB_MODULE)
      : LOB_MODULE;

  if (value === 1 || value === '1') return LOB_MODULE;
  if (value === 2 || value === '2') return DB_MODULE;
  if (typeof value !== 'string') return normalizedFallback;

  switch (value.trim().toLowerCase()) {
    case LEGACY_LOB_MODULE:
    case LOB_MODULE:
      return LOB_MODULE;
    case LEGACY_DB_MODULE:
    case DB_MODULE:
      return DB_MODULE;
    default:
      return normalizedFallback;
  }
}

export function normalizeModules(values, fallback = [LOB_MODULE]) {
  const normalizedFallback = Array.isArray(fallback)
    ? Array.from(new Set(fallback.map((value) => normalizeModule(value, null)).filter(Boolean)))
    : [LOB_MODULE];
  const fallbackModules = normalizedFallback.length > 0 ? normalizedFallback : [LOB_MODULE];

  if (!Array.isArray(values)) return fallbackModules;

  const normalized = values
    .map((value) => normalizeModule(value, null))
    .filter(Boolean);

  return normalized.length > 0 ? Array.from(new Set(normalized)) : fallbackModules;
}

export function getStoredModule(fallback = LOB_MODULE) {
  const storedModule = localStorage.getItem('module');
  if (storedModule) return normalizeModule(storedModule, fallback);

  const legacyModule = localStorage.getItem('mode_scope');
  const normalized = normalizeModule(legacyModule, fallback);
  localStorage.setItem('module', normalized);
  localStorage.removeItem('mode_scope');

  return normalized;
}

export function setStoredModule(value, fallback = LOB_MODULE) {
  const normalized = normalizeModule(value, fallback);
  localStorage.setItem('module', normalized);
  localStorage.removeItem('mode_scope');

  return normalized;
}

export function moduleToHeader(value, fallback = LOB_MODULE) {
  return normalizeModule(value, fallback);
}

export function getStoredModuleHeader(fallback = LOB_MODULE) {
  return moduleToHeader(getStoredModule(fallback), fallback);
}

export function isDbModule(value) {
  return normalizeModule(value) === DB_MODULE;
}

export function isLobModule(value) {
  return normalizeModule(value) === LOB_MODULE;
}

export function isSameModule(left, right) {
  return normalizeModule(left) === normalizeModule(right);
}

export function moduleToBadgeClass(value) {
  return isDbModule(value) ? DB_MODULE : LOB_MODULE;
}

export function moduleToTranslationKey(value) {
  return isDbModule(value) ? 'global.module.db' : 'global.module.lob';
}

export function moduleToFallback(value) {
  return isDbModule(value) ? 'DB' : 'LOB';
}

export function moduleToSortValue(value) {
  return isDbModule(value) ? 'db' : 'lob';
}
